import {
  Flex,
  Form,
  message,
  Slider,
} from "antd";
import React, { useState } from "react";
import {CustomButton} from "../../../components";
import MetricsCustomInput from "../../../components/MetricsCustomInput";
import { sendtMetrics } from "../../../api's/homeAPI";
import { useNavigate } from "react-router-dom";
import { useToken } from "../../../common/helper";

const ModifyBuffer = ({ selectedMetircData, closeModal, onSuccess }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { token, removeToken, getUserID } = useToken();

  console.log('first, s', selectedMetircData)

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  
  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      const model = {
        ...values,
        target_key: 'on_time_buffer',
        // target_key: selectedMetircData?.target_key || null,
      };
      handleSetTargetMetrics(model);
    }
  };

  const handleSetTargetMetrics = (model) => {
    sendtMetrics(token, model)
    .then((res) => {
      const data = res?.data || null;
      if (data) {
        if (data?.data?.is_success) {
          message.success(data?.data?.message);
            form.resetFields();
            onSuccess();
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      });
  };

  const [disabled, setDisabled] = useState(selectedMetircData?.on_time_buffer || 0);

  const onChange = (checked) => {
    setDisabled(checked);
  };

  const handleReset = () => {
    setDisabled(0)
    // form.setFieldsValue({ target_value: 0 }); 
    let model = {
      target_value: 0,
      target_key: 'on_time_buffer',
    };
    handleSetTargetMetrics(model)
  }
  
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={{target_value: selectedMetircData?.on_time_buffer || 0,
      }}
    >
      <Flex gap={16} align="center">
        <Form.Item name="target_value">
          <Slider
            defaultValue={30}
            step={15}
            min={0}
            max={120}
            onChange={onChange}
            style={{ width: "216px",}}
            trackStyle={{ backgroundColor: '#266EF1' }} 
          />
        </Form.Item>
        <MetricsCustomInput
          value={disabled}
          disabled={true}
          placeholder="0"
          height="36px"
          width={"120px"}
          border="0px"
          bgColor="#F3F3F3"
          textColor="#000"
          borderRadius="6px"
          placeholderColor="#5E5E5E"
          lineHeight="38px"
          suffix={`minutes`}
        />
      </Flex>

      <Flex
        style={{
          position: "sticky",
          bottom: "0",
          paddingTop: "28px",
        }}
        gap={8}
        justify="flex-end"
      >
        <CustomButton
          text="Reset"
          onClick={handleReset}
          width={60}
          height={40}
          bgColor="#fff"
          color="#000"
          fontSize={14}
          fontWeight={600}
          borderRadius={8}
          boxShadow={"none"}
        />
        <CustomButton
          text="Save"
          htmlType="submit"
          width={60}
          height={40}
          bgColor="#000"
          color="#fff"
          fontSize={14}
          fontWeight={600}
          borderRadius={8}
          boxShadow="0px 4px 16px 0px rgba(0, 0, 0, 0.27)"
        />
      </Flex>
    </Form>
  );
};

export default ModifyBuffer;
